function c(o) {
  var t = [];
  function n(r) {
    r.forEach(function (e) {
      t.push(e), e.componentInstance && n(e.componentInstance.$children.map(function (i) {
        return i.$vnode;
      })), e.children && n(e.children);
    });
  }
  return n(o), t;
}
function f(o, t) {
  var n = t.$vnode.componentOptions;
  if (!(!n || !n.children)) {
    var r = c(n.children);
    o.sort(function (e, i) {
      return r.indexOf(e.$vnode) - r.indexOf(i.$vnode);
    });
  }
}
export { f as sortChildren };
